const endocrineDisorders = [
    "Diabetes (Type 1)",
    "Diabetes (Type 2)",
    "Diabetes (Type 3)",
    "Obesity",
    "Thyroid Disorders (e.g., Hypothyroidism and Hyperthyroidism)",
    "Polycystic Ovary Syndrome (PCOS)",
    "Metabolic Syndrome",
    "Cushing's Syndrome",
    "Addison's Disease",
    "Hirsutism",
    "Gestational Diabetes",
    "Acromegaly",
    "Hyperparathyroidism",
    "Adrenal Insufficiency",
    "Pheochromocytoma",
    "Diabetic Neuropathy",
    "Diabetic Retinopathy",
    "Diabetic Nephropathy",
]

const endocrine = endocrineDisorders.reduce((accumulator, disease) => {
    accumulator.push({category: 'Endocrine', disease})
    return accumulator
}, [])

export default endocrine